import { $, $$ } from 'src/shared/js/utils/dom';
import { Accordion } from '@3pc/accordion';
import { slideOpen, slideClose } from 'src/shared/js/modules/slide-open';

class Header {
  constructor(params) {
    this.container = params.container;
    this.firstLevels = params.firstLevels;
    this.burgerButton = $('.header__burger-button', this.container);
    this.accordion = $('.header__accordion', this.container);
    this.openClass = 'header--is-open';
    this.menuIsOpen = false;
    this.breakpointDesktop = 1280;
    this.breakpointTablet = 744;
    this.mobileAccordions = [];
    this.mobileAccordionsInitiated = false;
    this.slideDirection =
      window.innerWidth <= this.breakpointDesktop &&
      window.innerWidth > this.breakpointTablet
        ? 'horizontal'
        : 'vertical';
    this.slideDirectionChange = false;
    this.focusableElements = $$('a, button', this.accordion);
  }

  toggleMenu = () => {
    const isOpen = this.burgerButton.getAttribute('aria-expanded');

    if (isOpen === 'false') {
      this.openMenu();
    } else {
      this.closeMenu();
    }
  };

  openMenu = () => {
    slideOpen(this.accordion, 300, 'ease-in-out', this.slideDirection);
    this.burgerButton.setAttribute('aria-expanded', true);
    this.accordion.setAttribute('aria-hidden', false);
    this.container.classList.add(this.openClass);
    document.body.classList.add('nav-is-open');
    this.menuIsOpen = true;
  };

  closeMenu = async () => {
    await slideClose(this.accordion, 300, 'ease-in-out', this.slideDirection);
    this.burgerButton.setAttribute('aria-expanded', false);
    this.accordion.setAttribute('aria-hidden', true);
    this.container.classList.remove(this.openClass);
    document.body.classList.remove('nav-is-open');
    this.menuIsOpen = false;
  };

  initMobileAccordions = () => {
    if (
      window.innerWidth <= this.breakpointDesktop &&
      !this.mobileAccordionsInitiated
    ) {
      firstLevels.forEach(level => {
        const handler = $('.nav-main__level-1-button', level);
        const target = $('.nav-main__level-2-accordion', level);
        const targetInner = $('.nav-main__level-2-accordion-inner', level);

        if (handler) {
          const mobileAccordion = new Accordion({
            handler,
            target,
            targetInner,
            easing: 'easeInOutCubic',
            duration: 300,
            openClassName: 'is-active',
          });

          this.mobileAccordions.push(mobileAccordion);
        }
      });

      this.mobileAccordions.forEach(accordion => {
        accordion.init();
      });
      this.mobileAccordionsInitiated = true;
    }
  };

  handleResize = async () => {
    if (window.innerWidth <= this.breakpointDesktop) {
      if (!this.mobileAccordionsInitiated) {
        this.initMobileAccordions();
        this.mobileAccordionsInitiated = true;
      }
    } else {
      if (this.mobileAccordionsInitiated) {
        this.mobileAccordions.forEach(accordion => {
          accordion && accordion.destroy();
        });

        this.mobileAccordionsInitiated = false;
        this.mobileAccordions = [];
      }
    }

    if (
      window.innerWidth <= this.breakpointDesktop &&
      window.innerWidth > this.breakpointTablet
    ) {
      if (!this.slideDirectionChange) {
        if (this.menuIsOpen) await this.closeMenu();
        this.accordion.removeAttribute('style');
        this.accordion.style.width = 0;
        this.slideDirection = 'horizontal';
        this.slideDirectionChange = true;
      }
    } else {
      if (this.slideDirectionChange) {
        if (this.menuIsOpen) await this.closeMenu();
        this.accordion.removeAttribute('style');
        this.accordion.style.height = 0;
        this.slideDirection = 'vertical';
        this.slideDirectionChange = false;
      }
    }
  };

  closeOnEscape = e => {
    window.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.menuIsOpen) {
        this.closeMenu();
        this.burgerButton.focus();
      }
    });
  };

  handleKeyboardFocus = () => {
    const lastFocusableElement =
      this.focusableElements[this.focusableElements.length - 1];

    this.focusableElements.forEach(elem => {
      elem.addEventListener('keydown', e => {
        if (e.key === 'Tab') {
          // focus menu toggle when a user tabs away from the last menu item
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            this.burgerButton.focus();
          }
        }
      });
    });
  };

  bindEvents = () => {
    window.addEventListener('resize', () => this.handleResize());
    this.burgerButton &&
      this.burgerButton.addEventListener('click', this.toggleMenu.bind(this));
    this.closeOnEscape();
    this.handleKeyboardFocus();
  };

  init = () => {
    this.bindEvents();
    this.initMobileAccordions();
  };
}

const header = $('.header');
const firstLevels = header && $$('.nav-main__level-1-item', header);

header &&
  firstLevels.length &&
  new Header({
    container: header,
    firstLevels,
  }).init();
